module.exports = __webpack_public_path__ + "img/u1225.3ed3fc1b.svg";